(function () {
	'use strict';
	
	angular.module('smb-app')
		.factory('smbToDoListDataStore', ['$q', '$interval', 'gettextCatalog', 'smbToDoListService', 'smbSortService', ToDoListDataStore]);
	
	/**
	 * @ngdoc service
	 * @name smb-app.smbContentTypesDataStore
	 * 
	 * @description
	 * Manages the state for the content types configuration.
	 */
	function ToDoListDataStore($q, $interval, gettextCatalog, smbToDoListService, smbSortService) {

		var _documents = null;

		var ASSIGNED_DATE = '&&_AirBase_Assigned_Date';
		var CONST_TODOLIST_POLL_INTERVAL = 20000;
		var _count = 0;	
		var _interval;	

		return {
			/**
			 * @ngdoc property
			 * @name smbContentTypesDataStore.contentTypes
			 * @propertyOf smb-app.smbContentTypesDataStore
			 * 
			 * @description
			 * All content types that belong to the current content type group.
			 */
			get documents() {
				return _documents;
			},

			/**
			 * @ngdoc method
			 * @name toDoListDataStore.getDocuments
			 * @methodOf smb-app.toDoListDataStore
			 * 
			 * @description
			 * Loads and returns all content types for a specific content type group by group id.
			 * 
			 * @param {Number} groupId The content type group id
			 * 
			 * @returns {Deferred} A promise that resolves to a collection of content types.
			 */
			getDocuments: getDocuments,

			sortByDate: sortByDate,

			sortByType: sortByType,

			sortByStatus: sortByStatus,

			loadCount: loadCount,

			init: init,

			/**
			 * @ngdoc method
			 * @name smbToDoListDataStore#clear
			 * @methodOf smb-app.toDoListDataStore
			 * @kind function
			 * 
			 * @description
			 * Clears the interval that was initiated by @see init
			 */
			clear: clear,

			get count() { return _count; }
			
		};	

		function getDocuments() {
			return smbToDoListService.getDocuments()
				.then(function (types) {
					_documents = types.map(function(doc) {
						var d;
						d = doc;
						var index = doc.DocumentAutoName ? doc.DocumentAutoName.indexOf('&&_AirBase_') : -1;
						if (index !== -1) {
							d.DocumentAutoName = doc.DocumentAutoName.substring(0, index > 0 ? index - 5 : 0);
						}						
						var contentStatus = doc.StatusInformation.filter(function(tt) {
							return (tt.TagTypeName.match(/&&_AirBase_Content_Status/));
						});
						var todoStatus = doc.StatusInformation.filter(function(tt) {
							return (tt.TagTypeName.match(/&&_AirBase_ToDo_Status/));
						});
						d.DateAssigned = doc.StatusInformation.filter(function(tt) {
							return (tt.TagTypeName.match(/&&_AirBase_Assigned_Date/));
						});
						if (contentStatus != null && contentStatus.length > 0 && contentStatus[0].Tags[0].length > 0) {
							d.Status = contentStatus[0].Tags[0];
						}
						else if (todoStatus != null && todoStatus.length > 0 && todoStatus[0].Tags[0].length > 0) {
							d.Status = todoStatus[0].Tags[0];
						}
						else {
							d.Status = '';
						}

						if (d.DateAssigned != null && d.DateAssigned.length > 0) {
							d.DateAssigned = d.DateAssigned[0].Tags[0];
						}					
						return d;
					});
					sortByDate(false);
					return _documents;
				});
		}

		function sortByDate(params) {
			_documents.sort(function(a, b) {
				var result = smbSortService.sortDate(new Date(b.DateAssigned.replace(/T(\d:){2}(\d){1}/, '')), new Date(a.DateAssigned.replace(/T(\d:){2}(\d){1}/, '')));
				if (result === 0 && a.DocumentAutoName !== null && b.DocumentAutoName !== null) {
					result = a.DocumentAutoName.toLowerCase().localeCompare(b.DocumentAutoName.toLowerCase());
				}
				return result;
			});
			if (!params) {
				_documents.reverse();
			}
		}

		function sortByType(params) {
			_documents.sort(function(a,b) {
				return smbSortService.sortByString(a.LibraryName + a.FolderName, b.LibraryName + b.FolderName, params);
			});			
		}

		function sortByStatus(params) {
			_documents.sort(smbSortService.sortObjectByStringProperty('Status', params));
		}

		function init() {
			if (!_interval) {
				_interval = $interval(function() {
					loadCount();
				}, CONST_TODOLIST_POLL_INTERVAL);
			}
		}

		function clear() {
			if (angular.isDefined(_interval)) {
				$interval.cancel(_interval);
				_interval = undefined;
			}
		}

		function loadCount() {
			return smbToDoListService.getCount()
				.then(function (count) {
					_count = count;
					return count;
				});
		}
	}
}());


//////////////////
// WEBPACK FOOTER
// ./app/dataStores/toDoListDataStore.js
// module id = 129
// module chunks = 1